'use strict';

import { service } from '@/plugins/feathers-client';
import { FilterType } from '@/store/constants';

import * as getters from './getters';
import * as mutations from './mutations';
import * as actions from './actions';


export default service('actions', {
	getters,
	mutations,
	actions,
	state: {
		// @override
		setCurrentOnGet: false,
		setCurrentOnCreate: false,

		// @enhance
		isReady: false,
		filter: { type: FilterType.all, value: null },
		editDialog: {
			visible: false,
			copy: {},
		},
	},
	instanceDefaults: {
		tone: 0,
		risk: 0,
	}
});
